
        
    const runtime = require("../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
            const __nunjucks_template_import__filter_t = require("../../../nunjucks/t.js");
            __nunjucks_module_dependencies__.filters['t'] = {
                module: __nunjucks_template_import__filter_t && __nunjucks_template_import__filter_t.default || __nunjucks_template_import__filter_t,
                async: false
            };
    
        
            __nunjucks_module_dependencies__.templates["note/views/templates/note-panel.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"note-panel-region\">\n  <div class=\"note-container\">\n    <div class=\"note-actions no-select\">\n      <i\n        class=\"pwai-content-expand expand-notes\"\n        title=\"";
output += runtime.suppressValue(env.getFilter("t").call(context, "Expand all notes","notes.panel.expand"), env.opts.autoescape);
output += "\"\n      ></i>\n      <i\n        class=\"pwai-content-collapse collapse-notes\"\n        title=\"";
output += runtime.suppressValue(env.getFilter("t").call(context, "Collapse all notes","notes.panel.collapse"), env.opts.autoescape);
output += "\"\n      ></i>\n      <i\n        class=\"pwai-print print-notes\"\n        title=\"";
output += runtime.suppressValue(env.getFilter("t").call(context, "Print notes or save as PDF","notes.panel.print_title"), env.opts.autoescape);
output += "\"\n      ></i>\n    </div>\n    <div id=\"notes\">\n      <!-- note list/form goes here -->\n    </div>\n  </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "note/views/templates/note-panel.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "note/views/templates/note-panel.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["note/views/templates/note-panel.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    